<template>
  <el-dialog :close-on-click-modal="false" append-to-body title="分类设置" :visible.sync="isShow" width="400px" @closed="closed">
    <el-form ref="form" :model="formData" :rules="rules" label-width="130px">
      <el-form-item label="税收分类名名称:" prop="rateName">
        <el-input v-model.trim="formData.rateName" clearable></el-input>
      </el-form-item>
      <el-form-item label="税收分类名编码:" prop="rateCode">
        <el-input v-model.trim="formData.rateCode" clearable></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { taxRateTypeAdd } from '@/api/finance'
export default {
  data () {
    return {
      isShow: false,
      loading: false, // 加载请求
      formData: {
        rateCode: '',
        rateName: ''
      },
      rules: {
        rateName: [
          { required: true, message: '请输入税收分类名名称', trigger: 'blur' }
        ],
        rateCode: [
          { required: true, message: '请输入税收分类名编码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    show () {
      this.isShow = true
    },
    hide (emit) {
      emit && (this.$emit('success'))
      this.isShow = false
    },
    closed () {
      this.$nextTick(_ => {
        this.$refs.form.resetFields()
      })
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.loading = true
        taxRateTypeAdd(this.formData)
          .then(res => {
            if (res.data.success) {
              this.$message.success('添加成功')
            }
          }).finally(data => {
            this.hide(true)
            let timer = setTimeout(() => {
              this.loading = false
              clearTimeout(timer)
            }, 500)
          })
      })
    }
  }
}
</script>

<style>
</style>
